import { CompetencyMapSelectPartsInput } from "@generated/graphql";

export type CompetencyMapSelectedParts = Pick<
  CompetencyMapSelectPartsInput,
  "competencyIds" | "knowledgeBockIds" | "questionIds" | "skillIds"
>;

export const COMPETENCY_MAP_SELECT_PARTS_QUERY_PARAMS = {
  competencyIds: "competencyIds",
  knowledgeBockIds: "knowledgeBockIds",
  questionIds: "questionIds",
  skillIds: "skillIds",
} as const;

const normalizeIds = (value: unknown): string[] | undefined => {
  if (!value) return undefined;

  if (Array.isArray(value)) {
    const result = value
      .flatMap((item) => String(item).split(","))
      .map((item) => item.trim())
      .filter(Boolean);

    return result.length ? result : undefined;
  }

  if (typeof value === "string") {
    const result = value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);

    return result.length ? result : undefined;
  }

  return undefined;
};

export const getCompetencyMapSelectPartsQueryParams = (selectParts?: CompetencyMapSelectedParts) => ({
  [COMPETENCY_MAP_SELECT_PARTS_QUERY_PARAMS.competencyIds]: selectParts?.competencyIds?.length
    ? selectParts.competencyIds.join(",")
    : undefined,
  [COMPETENCY_MAP_SELECT_PARTS_QUERY_PARAMS.knowledgeBockIds]: selectParts?.knowledgeBockIds?.length
    ? selectParts.knowledgeBockIds.join(",")
    : undefined,
  [COMPETENCY_MAP_SELECT_PARTS_QUERY_PARAMS.questionIds]: selectParts?.questionIds?.length
    ? selectParts.questionIds.join(",")
    : undefined,
  [COMPETENCY_MAP_SELECT_PARTS_QUERY_PARAMS.skillIds]: selectParts?.skillIds?.length
    ? selectParts.skillIds.join(",")
    : undefined,
});

export const getCompetencyMapSelectPartsFromQueryParams = (
  params: Record<string, unknown>
): CompetencyMapSelectedParts | undefined => {
  const competencyIds = normalizeIds(params[COMPETENCY_MAP_SELECT_PARTS_QUERY_PARAMS.competencyIds]);
  const knowledgeBockIds = normalizeIds(params[COMPETENCY_MAP_SELECT_PARTS_QUERY_PARAMS.knowledgeBockIds]);
  const questionIds = normalizeIds(params[COMPETENCY_MAP_SELECT_PARTS_QUERY_PARAMS.questionIds]);
  const skillIds = normalizeIds(params[COMPETENCY_MAP_SELECT_PARTS_QUERY_PARAMS.skillIds]);

  if (!competencyIds?.length && !knowledgeBockIds?.length && !questionIds?.length && !skillIds?.length) {
    return undefined;
  }

  return {
    competencyIds,
    knowledgeBockIds,
    questionIds,
    skillIds,
  };
};
